<template>
  <div>
    <ValidationObserver ref="form">
      <form @submit.prevent="handleSubmit">
        <div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <h3 class="mb-4"><strong>{{ $t('InfoGeneral') }}</strong></h3>
            </div>
            <div class="vx-col md:w-1/2 w-full">
               <div class="vx-col w-full mb-3">
          <label><strong>{{ $t('Nombre') }}</strong></label>
          <p>{{ sale.name }}</p>
        </div>
            </div>

        <div class="vx-col md:w-1/2 w-full">
               <div class="vx-col w-full mb-3">
          <label><strong>{{ $t('Descripcion') }}</strong></label>
          <p>{{ sale.details }}</p>
        </div>
        </div>


         <div class="vx-col md:w-1/2 w-full">
               <div class="vx-col w-full mb-3">
          <label><strong>{{ $t('sale.SaleCode') }}</strong></label>
          <p>{{ sale.sale_code }}</p>
        </div>
         </div>

        <div class="vx-col md:w-1/2 w-full">
               <div class="vx-col w-full mb-3">
          <label><strong>{{ $t('CreatedAt') }} </strong></label>
          <p>{{ sale.created_at }}</p>
        </div>
        </div>

        <div class="vx-col md:w-1/2 w-full">
          <div class="vx-col w-full mb-3">
            <label><strong>{{ $t('FinishedAt') }} </strong></label>
            <p>{{ sale.finished_at}}</p>
          </div>
        </div>
        <div v-if="sale.global" class="vx-col md:w-1/2 w-full">
          <div class="vx-col w-full mb-3">
            <label><strong>{{ $t('sale.GlobalSale') }} </strong></label>
          </div>
        </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import draggable from 'vuedraggable';
import ImageDropzone from '../ImageDropzone';
import { mapActions, mapGetters } from 'vuex';

export default {
     props: {
    sale: {
      type: Object,
      required: true,
    },

  },

  components: {
    ImageDropzone,
    draggable,
  },


};
</script>
<style></style>
